(function () {
  var KLAVIYO_COMPANY_ID = 'JsqjcD';
  var KLAVIYO_BIS_URL =
    'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + KLAVIYO_COMPANY_ID;

  var modal = null;
  var form = null;
  var titleEl = null;
  var emailInput = null;
  var errorEl = null;
  var successEl = null;
  var submitBtn = null;
  var activeVariantId = null;
  var activeProductTitle = '';

  function getModalElements() {
    if (modal) return;
    modal = document.getElementById('klaviyo-bis-modal');
    if (!modal) return;
    form = modal.querySelector('.kl-bis-modal__form');
    titleEl = modal.querySelector('.kl-bis-modal__title');
    emailInput = modal.querySelector('#kl-bis-email');
    errorEl = modal.querySelector('.kl-bis-modal__error');
    successEl = modal.querySelector('.kl-bis-modal__success');
    submitBtn = modal.querySelector('.kl-bis-modal__submit');
  }

  function openModal(variantId, productTitle) {
    getModalElements();
    if (!modal || !variantId) return;

    activeVariantId = variantId;
    activeProductTitle = productTitle || '';

    titleEl.textContent = activeProductTitle;
    emailInput.value = '';
    errorEl.hidden = true;
    errorEl.textContent = '';
    successEl.hidden = true;
    form.hidden = false;
    submitBtn.disabled = false;

    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('scroll-locked');
    setTimeout(function () {
      emailInput.focus();
    }, 50);
  }

  function closeModal() {
    getModalElements();
    if (!modal) return;
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('scroll-locked');
  }

  function buildPayload(email, variantId) {
    return {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email
              }
            }
          }
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: '$shopify:::$default:::' + variantId
            }
          }
        }
      }
    };
  }

  function handleSubmit(event) {
    event.preventDefault();
    getModalElements();
    if (!form || !activeVariantId) return;

    var email = emailInput.value.trim();
    if (!email) {
      errorEl.textContent = 'Please enter your email address.';
      errorEl.hidden = false;
      return;
    }

    submitBtn.disabled = true;
    errorEl.hidden = true;

    fetch(KLAVIYO_BIS_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        revision: '2024-06-15'
      },
      body: JSON.stringify(buildPayload(email, activeVariantId))
    })
      .then(function (response) {
        if (response.status === 202) {
          form.hidden = true;
          successEl.hidden = false;
          setTimeout(closeModal, 2500);
          return;
        }
        return response.json().then(function (data) {
          var message = 'Something went wrong. Please try again.';
          if (data && data.errors && data.errors[0] && data.errors[0].detail) {
            message = data.errors[0].detail;
          }
          throw new Error(message);
        });
      })
      .catch(function (error) {
        errorEl.textContent = error.message || 'Something went wrong. Please try again.';
        errorEl.hidden = false;
        submitBtn.disabled = false;
      });
  }

  function syncBackInStockVisibility() {
    document.querySelectorAll('product-form').forEach(function (productForm) {
      var submitButton = productForm.querySelector('.product-form__submit[name="add"]');
      var bisTrigger = productForm.querySelector('.js-bis-btn');
      if (!submitButton || !bisTrigger) return;

      var isSoldOut = submitButton.hasAttribute('disabled') || submitButton.hasAttribute('data-sold-out');

      submitButton.hidden = isSoldOut;
      submitButton.classList.toggle('product-form__submit--hidden-for-bis', isSoldOut);
      bisTrigger.hidden = !isSoldOut;

      var variantInput = productForm.querySelector('[name="id"]');
      if (variantInput && variantInput.value) {
        bisTrigger.setAttribute('data-variant-id', variantInput.value);
      }
    });
  }

  function handleBisClick(event) {
    var trigger = event.target.closest('.js-bis-btn');
    if (!trigger || trigger.hidden) return;

    event.preventDefault();
    event.stopPropagation();

    var variantId = trigger.getAttribute('data-variant-id');
    var productTitle = trigger.getAttribute('data-product-title') || document.title;

    openModal(variantId, productTitle);
  }

  function initModal() {
    getModalElements();
    if (!modal) return;

    modal.querySelectorAll('[data-kl-bis-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    form.addEventListener('submit', handleSubmit);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal && !modal.hidden) {
        closeModal();
      }
    });
  }

  document.addEventListener('click', handleBisClick, true);
  document.addEventListener('DOMContentLoaded', function () {
    initModal();
    syncBackInStockVisibility();
  });
  document.addEventListener('klaviyo:bis:variant-change', function () {
    setTimeout(syncBackInStockVisibility, 50);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      setTimeout(syncBackInStockVisibility, 50);
    });
  }
})();
